export default "__VITE_ASSET__B0EgQD9L__"